up.compiler('.js-focus_on_click', function (element) {
  function onClick(e) {
    e.preventDefault()
    const otherElement = document.querySelector(element.dataset.focusTarget)
    if (otherElement) {
      otherElement.focus()
    }
  }

  element.addEventListener('click', onClick)

  return function () {
    element.removeEventListener('click', onClick)
  }
})
